export default "__VITE_ASSET__6j4fr_LM__"